import styled, { css } from 'styled-components';
export const StyledInfoCardContainer = styled.div<{
  background: boolean;
  $isSmall?: boolean;
}>`
  width: 100%;
  max-width: ${({
  $isSmall
}) => $isSmall ? '27rem' : '34rem'};
  padding: 1.6rem;
  border-radius: 0.5rem;

  @media screen and (min-width: ${({
  theme
}) => theme.sizes.lg}) {
    min-height: 10.4rem;
  }

  ${({
  background
}) => background ? css`
          background-color: #1c2538;
          border: 1px solid #3e475a;
        ` : css`
          background-color: #151c2b;
        `}
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  justify-content: center;

  p:nth-child(1) {
    font-size: 1.8rem;
    font-weight: ${({
  theme
}) => theme.fonts.weight.bold};
  }

  p:nth-child(2) {
    font-size: ${({
  theme
}) => theme.fonts.sizes.small};
  }

  a {
    color: #719cf9;
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  }
`;